





















































import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IBank } from '@/store/modules/components/states'
import { ICenter } from '@/store/modules/views/center/states'
import { IUser } from '@/store/modules/views/user/states'
import { IMonthlyContract } from '@/store/modules/views/monthlyContract/states'
import liff from '@line/liff'

@Component
export default class MonthlyContract extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private monthlyContractDialog = false
  private deleteDialog = false
  private resetDialog = false
  private zoomImageDialog = false
  private slipImg = ''
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('monthlyContract/getMonthlyContractList')
  private getMonthlyContractList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('monthlyContract/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('monthlyContract/itemLists')
  private itemLists!: IMonthlyContract[]

  @Getter('monthlyContract/pagination')
  private pagination!: () => void

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  private openContract(contract: IMonthlyContract) {
    const base64 = 'data:application/pdf;base64,' + encodeURI(contract.contract)
    if (liff.getOS() === 'web') {
      let win = window.open()
      if (!win) {
        win = window
      }
      win.document.write('<iframe src="' +
        base64 +
        '" frameborder="0" width="100%" height="100%" allowfullscreen ' +
        'style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"></iframe>',
      )
    } else if (liff.isInClient()) {
      liff.openWindow({
          url: `${window.location.origin}${window.location.pathname}?contract=${contract._id}`,
          external: true,
      })
    } else {
      window.open(base64)
    }
    return contract.contract
  }

  private async callApi(lists) {
    this.loadingDataTable = true
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
    })
    this.loadingDataTable = false
  }

  private async getMonthlyContracts() {
    const list = await this.callApi(this.getMonthlyContractList)
    return list
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(() => this.getMonthlyContracts(), 1000)
  }

  private openDialog(monthlyContract: {name: string, email: string, id: string}, modelDialog: 'monthlyContractDialog') {
    this.currentData = _.cloneDeep(monthlyContract)
    this[modelDialog] = true
  }

  private async mounted() {
    await this.getMonthlyContracts()
    if (this.$route.query.contract) {
      const contractId = this.$route.query.contract
      const contract = _.find(this.itemLists, (item) => (item._id === contractId))
      if (contract) {
        this.openContract(contract)
      }
    }
  }
}
